exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-custom[data-v-0bc85a74]{min-height:48px;max-height:448px;overflow-y:auto;padding:0}.v-item-group.v-bottom-navigation .v-btn[data-v-0bc85a74]{min-width:64px}", ""]);

// exports
